import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useNotifications } from "@/shared/composables/useNotifications.composable";
import type { RegistrationData } from "@/app/registration-app/user/shared/@types/RegistrationData";
import {
  registerUser,
  serializeDataForRegisterUser,
} from "@/app/registration-app/user/shared/services/registerUser.service";

export const useRegisterUser = (onActionFinished: () => void) => {
  const { t } = useI18n();
  const { addErrorSnackbar } = useNotifications();

  const isRegisteringUser = ref(false);

  const onRegisterUser = async (data: RegistrationData) => {
    try {
      isRegisteringUser.value = true;
      await registerUser(serializeDataForRegisterUser(data));
      onActionFinished();
    } catch {
      addErrorSnackbar(t("registration.user.failed.title"));
    } finally {
      isRegisteringUser.value = false;
    }
  };

  return {
    isRegisteringUser,
    onRegisterUser,
  };
};
